import { formatDate } from '../AccordionList/AccordionList';


let columnSpecs = [
    {
        name: 'CF Contribuente', 
        selector: row => row.contribuente,
        width: '140px'
    },
    {
        name: 'Nome Versante', 
        selector: row => row.nome_versante,
        width: '150px',
        wrap: true
    },
    {
        name: 'CF Versante', 
        selector: row => row.codice_fiscale,
        width: '170px',
    },
    {
        name: 'Tipo Versante', 
        selector: row => row.tipo_versante
    },
    {
        name: 'Cognome', 
        selector: row => row.cognome,
        wrap: true
    },
    {
        name: 'Nome', 
        selector: row => row.nome,
        wrap: true
    },
    {
        name: 'Sesso', 
        selector: row => row.sesso,
        width: '100px'
    },
    {
        name: 'Data di Nascita', 
        selector: row => row.data_di_nascita, 
        format: row => formatDate(row.data_di_nascita),
        width: '130px'
    },
    {
        name: 'Comune Nascita', 
        selector: row => row.comune_nascita,
        width: '140px',
        wrap: true
    },
    {
        name: 'Provincia Nascita', 
        selector: row => row.provincia_nascita
    },
    {
        name: 'IBAN', 
        selector: row => row.iban, 
        width: '220px'
    }
];

// add properties to all columns
columnSpecs = columnSpecs.map(item => (
    {
        ...item, 
        sortable: true,
        reorder: true
    }
));

export const tableSpecs = {
    "columns": columnSpecs
}
